import React from 'react';
import styled from '@emotion/styled';

interface UserProfileProps {
  userName?: string;
  profileImage?: string;
}

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0 24px 0;
`;

const ProfileImageWrapper = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: white;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const DefaultAvatar = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  color: white;
  font-weight: 600;
`;

const UserName = styled.h1`
  font-size: 28px;
  color: white;
  margin: 0;
  font-weight: 600;
`;

export const UserProfile: React.FC<UserProfileProps> = ({ 
  userName = 'User',
  profileImage 
}) => {
  // 이름의 첫 글자 추출 (기본 아바타용)
  const getInitials = (name: string) => {
    const words = name.split(' ');
    if (words.length >= 2) {
      return words[0][0] + words[words.length - 1][0];
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <ProfileContainer>
      <ProfileImageWrapper>
        {profileImage ? (
          <ProfileImage src={profileImage} alt={userName} />
        ) : (
          <DefaultAvatar>{getInitials(userName)}</DefaultAvatar>
        )}
      </ProfileImageWrapper>
      <UserName>{userName}</UserName>
    </ProfileContainer>
  );
};

export default UserProfile;
